const SET_DIALOG = 'SET_DIALOG';

const state = {
   show: false,
   title: '',
   message: '',
   type: 'info', // "info" | "success" | "error"
   refresh: false,
   redirect: null,
};

const actions = {
   setAlert: ({ commit }, data) => {
      const passData = {
         show: true,
         title: '',
         message: '',
         type: 'info',
         refresh: false,
         redirect: null,
      };

      for (const key in passData) {
         if (data[key] !== undefined) {
             passData[key] = data[key];
         }
     }

      switch (data.message) {
         case 'noData':
            passData.title = 'message.dataNotExist';
            passData.message = 'message.dataNotExistMsg';
            passData.type = 'error';
            break;
         case 'noPermission':
            passData.title = 'message.noPermissionTitle';
            passData.message = 'message.noPermission';
            passData.type = 'error';
            break;
         case 'tokenExpired':
            passData.title = 'message.tokenExpiredTitle';
            passData.message = 'message.tokenExpired';
            passData.type = 'error';
            passData.redirect = 'Login';
            break;
      }
      commit(SET_DIALOG, passData);
   },
   hideAlert: ({ commit }) => {
      commit(SET_DIALOG, {
         show: false,
         title: '',
         message: '',
         type: 'info',
         refresh: false,
         redirect: null,
      });
   }
}

const mutations = {
   [SET_DIALOG]: (state, data) => {
      for (const key in state) {
         if (data[key] !== undefined) {
            state[key] = data[key];
         }
     }
   },
}

export default {
   state,
   actions,
   mutations,
}
